const PUT = 'PUT';
const DELETE = 'DELETE';
const GET = 'GET';
const POST = 'POST';
const APPLICATION_JSON = 'application/json';
const APPLICATION_PDF = 'application/pdf';
export const CONTENT_DISPOSITION = 'Content-Disposition';

export const METHOD = {
  PUT,
  DELETE,
  GET,
  POST,
};

export const CONTENT_TYPE = {
  APPLICATION_JSON,
  APPLICATION_PDF,
};